import React, { useCallback } from "react";
import { UseEmblaCarouselType } from "embla-carousel-react";

enum DisableBtn {
    PREV = "prev",
    NEXT = "next",
}

// Custom hook for navigation buttons
const useNavigation = (emblaApi: UseEmblaCarouselType[1]) => {
    const [disabledBtn, setDisabledBtn] = React.useState<DisableBtn | null>(null);

    const onPrevButtonClick = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const onNextButtonClick = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    const onSelect = useCallback(() => {
        if (emblaApi) {
            const buttonStateMap = new Map([
                [!emblaApi.canScrollPrev() && !emblaApi.canScrollNext(), null],
                [!emblaApi.canScrollPrev(), DisableBtn.PREV],
                [!emblaApi.canScrollNext(), DisableBtn.NEXT],
            ]);

            for (const [condition, state] of buttonStateMap) {
                if (condition) {
                    setDisabledBtn(state);
                    return;
                }
            }

            setDisabledBtn(null);
        }
    }, [emblaApi]);

    React.useEffect(() => {
        if (!emblaApi) return;

        onSelect();
        emblaApi.on("reInit", onSelect);
        emblaApi.on("select", onSelect);

        return () => {
            emblaApi.off("reInit", onSelect);
            emblaApi.off("select", onSelect);
        };
    }, [emblaApi, onSelect]);

    return {
        prevBtnDisabled: disabledBtn === DisableBtn.PREV,
        nextBtnDisabled: disabledBtn === DisableBtn.NEXT,
        onPrevButtonClick,
        onNextButtonClick,
    };
};

export default useNavigation;
